import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Preloader = () => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1700);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-white"
        >
          <motion.img
            src="/logo.png"
            alt="Sunny's Construction Ltd"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="h-14 w-auto md:h-16"
          />
          <div className="mt-9 h-[3px] w-52 overflow-hidden bg-black/10">
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: "0%" }}
              transition={{ duration: 1.35, ease: [0.16, 1, 0.3, 1] }}
              className="bg-gold-shine h-full w-full"
            />
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="mt-5 text-[10px] uppercase tracking-[0.45em] text-black/40"
          >
            Building Quality · Delivering Trust
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
